import * as getters from '@/store/modules/session/getters'
import * as mutations from '@/store/modules/session/mutations'
import * as actions from '@/store/modules/session/actions'

const state = {
    currentAppThemeClientType: process.env.VUE_APP_THEME_CLIENT_TYPE !== 'null' ? process.env.VUE_APP_THEME_CLIENT_TYPE : 'particular',
    allUserInfo: null,
    sessionExpired: false, /* This var will be changed based of http client error of session expired `/
    allUserInfo: null, /* All info provided by authentication api on login */
	userSession: null, /* user session info */
    outOfBandValidationType: 'USSD',
    savedEntityTillOutOfBandValidation: null,
    rememberMeEntityInfo: null, /* entity rememberMe info with multiple acessions memorizes */
    /* planed structure
        rememberMeEntity: {
            entity: 234234234, // customer.bankingHolderId
            entityName: abasd asdasd // customer.name
            listOfAcessions: [{
                username: 123123, //param usado no login
                acessionNumber: 001429, // customer.username
                contractName: 'asdsad', // contractName
                avatarImageUrl: 'http://badjoras.png', // customer.avatarImageUrl
                type: COMPANY/PARTICULAR // depende da tab (existindo uma conta desse tipo)
                selected: true
            }]
        }
    */
    mobileBiometric: false, /* user mobileBiometric info */
    /* States used for session expired calculations */
    sessionTimer: null,
    localExpiryDate: null,
	localExpirySpan: null,
    showPopupsList: false,
    popupsList: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
